const TABS_TOKENS = {
  horizontal: {
    typography: {
      L: "h5",
      M: "body1",
      S: "caption1"
    },
    padding: {
      bottom: {
        L: "14",
        M: "8",
        S: "8"
      }
    },
    size: {
      L: "40",
      M: "32",
      S: "24"
    },
    tabsGap: {
      L: "24",
      M: "16",
      S: "12"
    },
    gap: {
      L: "8",
      M: "6",
      S: "4"
    },
    badge: {
      size: {
        L: "20",
        M: "14",
        S: "14"
      },
      typography: {
        L: "caption1",
        M: "caption2",
        S: "caption2"
      },
      padding: {
        L: "8",
        M: "6",
        S: "4"
      },
      border: {
        L: "0",
        M: "0",
        S: "0"
      }
    }
  },
  vertical: {
    typography: {
      L: "subtitle1",
      M: "subtitle1",
      S: "subtitle1"
    },
    padding: {
      bottom: {
        L: "0",
        M: "0",
        S: "0"
      }
    },
    size: {
      L: "40",
      M: "40",
      S: "40"
    },
    tabsGap: {
      L: "6",
      M: "6",
      S: "6"
    },
    gap: {
      L: "16",
      M: "16",
      S: "16"
    },
    badge: {
      size: {
        L: "18",
        M: "18",
        S: "18"
      },
      typography: {
        L: "caption1",
        M: "caption1",
        S: "caption1"
      },
      padding: {
        L: "8",
        M: "8",
        S: "8"
      },
      border: {
        L: "0",
        M: "0",
        S: "0"
      }
    }
  },
  shortHorizontal: {
    typography: {
      L: "caption1",
      M: "caption1",
      S: "caption1"
    },
    padding: {
      bottom: {
        L: "8",
        M: "8",
        S: "8"
      }
    },
    size: {
      L: "45",
      M: "45",
      S: "45"
    },
    tabsGap: {
      L: "24",
      M: "24",
      S: "24"
    },
    gap: {
      L: "0",
      M: "0",
      S: "0"
    },
    badge: {
      size: {
        L: "14",
        M: "14",
        S: "14"
      },
      typography: {
        L: "caption2",
        M: "caption2",
        S: "caption2"
      },
      padding: {
        L: "0",
        M: "0",
        S: "0"
      },
      border: {
        L: "2",
        M: "2",
        S: "2"
      }
    }
  },
  shortVertical: {
    typography: {
      L: "caption2",
      M: "caption2",
      S: "caption2"
    },
    padding: {
      bottom: {
        L: "0",
        M: "0",
        S: "0"
      }
    },
    size: {
      L: "72",
      M: "72",
      S: "72"
    },
    tabsGap: {
      L: "0",
      M: "0",
      S: "0"
    },
    gap: {
      L: "0",
      M: "0",
      S: "0"
    },
    badge: {
      size: {
        L: "20",
        M: "20",
        S: "20"
      },
      typography: {
        L: "caption1",
        M: "caption1",
        S: "caption1"
      },
      padding: {
        L: "0",
        M: "0",
        S: "0"
      },
      border: {
        L: "2",
        M: "2",
        S: "2"
      }
    }
  },
  maxWidth: "600"
};
const BADGE_SIZE = {
  s: "14",
  m: "18"
};
const BLURHASH_DEFAULT_INITIAL_SIZE = 32;
const DEFAULT_BLUR_HASH = "LEHV6nWB2yk8pyo0adR*.7kCMdnj";
export {
  BADGE_SIZE,
  BLURHASH_DEFAULT_INITIAL_SIZE,
  DEFAULT_BLUR_HASH,
  TABS_TOKENS
};
